import { useState, useEffect } from 'react'
import { toTreeData } from '@/common/utils/array';
import BrandService from '@/services/brand.service';

export default function useTreeBrand() {
  const [treeBrandData, setTreeBrandData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getBrands();
  }, []);

  const getBrands = async () => {
    setLoading(true);
    try {
      const res = await BrandService.getBrands();
      setTreeBrandData(toTreeData(res.data));
    } catch (error) {
      setTreeBrandData([])
    }
    setLoading(false);
  }

  return [treeBrandData, loading];
}
